import { Flex, Image, Card, CardHeader, Text, CardBody, HStack, Button, Box, Badge } from '@chakra-ui/react';
import kcookingtrip from '../assets/images/kcookingtrip.png';
import dessertguardians from '../assets/images/dessertguardians.png';
import googlebtn from '../assets/images/google_btn.png';
import applebtn from '../assets/images/apple_btn.svg';
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  const redirectToURL = () => {
    window.location.href = "https://kcookingtrip.onelink.me/YWsf/upisfprg";
  };

  return (
    <Flex direction="column" alignItems="center" flex="1" py={6} px={4} gap={5}>

      {/* KCooking Trip */}
      <Card
        maxW="sm"
        width="100%"
        overflow="hidden"
        borderRadius="2xl"
        boxShadow="0 8px 32px rgba(0,0,0,0.18)"
        border="none"
        transition="all 0.25s ease"
        _hover={{ transform: "translateY(-4px)", boxShadow: "0 16px 48px rgba(0,0,0,0.25)" }}
              >
        <Image src={kcookingtrip} alt="k-cookingtrip" />
        <CardHeader pb={1}>
          <Text
            fontSize="xl"
            fontWeight="bold"
            cursor="pointer"
            _hover={{ textDecoration: "underline" }}
            onClick={() => navigate("/kcookingsupport")}
          >
            KCookingTrip
          </Text>
          <Text fontSize="sm" color="gray.500">맛집의 탄생</Text>
        </CardHeader>
        <CardBody pt={2} pb={4}>
          <HStack spacing={3} justify="center">
            <Button onClick={redirectToURL} variant="unstyled" display="flex">
              <Image src={applebtn} alt="App Store" height="44px" />
            </Button>
            <Button onClick={redirectToURL} variant="unstyled" display="flex">
              <Image src={googlebtn} alt="Google Play" height="44px" />
            </Button>
          </HStack>
        </CardBody>
      </Card>

      {/* Dessert Guardians */}
      <Card
        maxW="sm"
        width="100%"
        overflow="hidden"
        borderRadius="2xl"
        boxShadow="0 8px 32px rgba(0,0,0,0.18)"
        border="none"
        transition="all 0.25s ease"
        _hover={{ transform: "translateY(-4px)", boxShadow: "0 16px 48px rgba(0,0,0,0.25)" }}
              >
        <Box position="relative">
          <Image src={dessertguardians} alt="dessert-guardians" />
          <Badge
            position="absolute"
            top={3}
            right={3}
            colorScheme="yellow"
            variant="solid"
            fontSize="xs"
            px={3}
            py={1}
            borderRadius="full"
          >
            열심히 개발중
          </Badge>
        </Box>
        <CardHeader pb={1}>
          <Text fontSize="xl" fontWeight="bold">Dessert Guardians</Text>
          <Text fontSize="sm" color="gray.500">디저트 수호대</Text>
        </CardHeader>
        <CardBody pt={2} pb={4}>
          <Text fontSize="sm" color="gray.400">Coming Soon</Text>
        </CardBody>
      </Card>

    </Flex>
  );
}

export default Home;
